import Vue from "vue";
import store from "@/store";
import Config from "@/config";
import {nick, realNameOf} from "@/utils/user";
import {
    date2DDMMYYYY, date2HHMM,
    date2Iso,
    date2Mysql,
    date2MysqlFull,
    iso2Date,
    iso2DDMMYYYY,
    iso2HHMM,
    mysql2Date,
    mysql2DDMMYYYY, mysql2HHMM
} from "@/utils/date";
import router from "@/router";
import {
    sortItems,
    colors,
    TABS,
    contextHasDelayedTill,
    rootContextId,
    sortByPrio,
    groupOfTask,
    topicOfTask,
    tagsOfTask,
    isTaskOfMyAttention,
    isTaskOverdue,
    isTaskDelayed,
    isTaskDone,
    isContextTaskInactive,
    isTaskInactive,
    isTaskTemplateActive,
    countContextInactiveTasks,
    countContextActiveTasks,
    contextFirstVisibleTask,
    isContextDelayed,
    isTopicDelayed,
    isTopicVirtual,
    isTopicDone,
    currentContextVisibleTasks,
    isTaskDeleted,
    tabs,
    sortTypes,
    isTaskDeferred,
    routeToTaskContext,
    isTaskStageItemDone,
    routeToTask,
    isRouteSomeTask,
    routeToTaskStageItem,
    PRIOS,
    isTaskTemplate,
    isTaskRepeated,
    SORT_TYPES,
    openContextIds,
    contextParams,
    isTaskActive,
    isTaskReminder,
    MODES,
    isTaskComment,
    isTaskNote,
    isTaskHidden,
    isTaskDraft, isTaskWithLargeContent, isTaskFullDraft,
    isComplexTask, repeatStatusText, routeOfTask, routeOfContext, routeOfContextTask, routeOf1Task, contextIdChainFor,
} from "@/utils/task";
import {mapRouteQuery, obtainRootContext, parseContextIds} from "@/utils/context";
import {fullContextItem, jointContexts, PRESETS} from "@/utils/pick";
import {clearName} from "../utils/task";
import {copy, flatArray, intersection, isMacOrIOs, parentsOf} from "@/utils/utils";
import {posLevel, splitPos} from "@/utils/pos";
import storage from "@/utils/storage";
import {obtainClientId} from "@/utils/auth";
import {chainOfRoute, isPannelViewOfContextId, routeOfContextAppend} from "@/utils/panels";

/**
 * Base component.
 * Encapsulates some widely used computed variables and methods.
 */
export default {
    /**
     * Область данных панели (см. panel-context.vue): внутри панели context/tasks/task - данные этой панели,
     * а не страницы. Вне панелей null - тогда используются данные страницы (store.page).
     */
    inject: {panelScope: {default: null}},
    data() {
        return {
            COLORS: colors,
            COLOR_NEW: colors.NEW,
            COLOR_TASK_TEMPLATE: colors.TASK_TEMPLATE,
            COLOR_TASK_TEMPLATE_STOPPED: colors.TASK_TEMPLATE_STOPPED,
            IMs: Config.IMs,

            tabItems: tabs,
        }
    },
    computed: {
        isError() {
            return !!this.$store.state.lastError;
        },
        lastError() {
            return this.$store.state.lastError;
        },
        hasData() {
            return this.session.isInited && this.page.isInited && !this.is403 && !this.is404;
        },
        hasSessionData() {
            return this.session.isInited;
        },
        hasContextData() {
            return this.session.isInited && this.context.isInited;
        },

        // session --------------------
        session() {
            return this.$store.state.session;
        },
        user() {
            return this.session.user;
        },
        currentUserNick() {
            return nick(this.user);
        },
        currentUserEmail() {
            return this.user.email;
        },
        currentUserName() {
            return this.user.firstName || this.user.name;
        },
        workspace() {
            return this.session.workspace;
        },
        onlineUsers() {
            return this.session.area?.onlineUsers?.filter(el => el.id !== this.user?.id);
        },
        /**
         * Current user has full access.
         * @returns {boolean}
         */
        isAuthorized() {
            //return this.$store.state.isAuthorized;
            return !this.isLimitedAccess;
        },
        /**
         * Current user has full access.
         * Alias for isAuthorized.
         * @returns {boolean}
         */
        isAuthed() {
            return this.isAuthorized;
        },
        isAnon() {
            return this.session.isAnon;
        },
        is403() {
            return this.session.isAnon && (
                !this.isRouteSomeTask
            );
        },
        is404() {
            // todo
            return false;
        },
        currentTask() {
            return this.session.currentTask;
        },
        oneTask() {
            return this.session.oneTask;
        },

        // ui -------------------
        ui() {
            return this.$store.state.ui;
        },
        pending() {
            return this.ui.pending;
        },
        isTaskFullscreen() {
            return this.ui.isTaskFullscreen;
        },
        isTaskWithAIChat() {
            return this.ui.isTaskWithAIChat;
        },
        isFirstLoad() {
            return this.ui.isFirstLoad;
        },
        isSessionClosing() {
            return this.ui.isSessionClosing;
        },
        isTaskPending() {
            return !!this.ui.pending.taskId;
        },
        isMacOrIOs() {
            return isMacOrIOs();
        },
        withMaximizedContent() {
            return this.ui.withMaximizedComments === false;
        },

        /**
         * @deprecated - use hasFullAccessToContext
         * @returns {default.computed.session.isAnon|boolean|boolean|*|boolean}
         */
        isLimitedAccess() {
            return this.isAnon || (
                this.context.isInited && !this.context.withFullAccess
            );
        },
        /**
         * @deprecated - use hasFullAccessToContext
         * @returns {boolean}
         */
        isFullAccess() {
            return !this.isLimitedAccess;
        },
        search: {
            get() {
                return this.ui.search.value;
            },
            set(v) {
                this.$store.commit("uiSetSearch", v);//$store.state.ui.search.value = v;
            }
        },
        isSearching() {
            return this.ui.search.isSearching;
        },
        is1TaskMode() {
            return this.isRoute1Task
                || (this.isRouteContext && this.context.item?.is1Task);
        },
        isBlockMode() {
            return this.isRoute1Task
                || (this.isRouteContext && this.context.item?.isBlock);
        },
        isContextWithFilters() {
            return !!(this.context?.item?.isGroup
                    //|| (this.context?.item?.isTask && this.context?.totalTasks )
                    || this.context?.item?.isUser
                    || this.context?.item?.isTag)
                //&& this.context?.totalTasks >= 1
                && !this.context?.item?.isProcess
                ;
        },
        isContextWithTitle() {
            return !!this.context?.item?.isTask
                && !this.context?.item?.isGroup
                ;
        },
        isContextWithProgress() {
            return this.context?.item?.withProgress;
        },
        isNotificationsMode() {
            return this.context.mode === MODES.NOTIFICATIONS;
        },

        // area ---
        area() {
            return this.session.area;
        },
        workspaces() {
            return this.area?.workspaces;
        },
        picks() {
            return this.area?.picks;
        },
        favoriteUsers() {
            return this.area?.favoriteUsers;
        },
        contexts() {
            return jointContexts(this.area);
        },
        groups() {
            return this.area?.groups;
        },
        topics() {
            return this.area?.topics;
        },
        /** Закреплённые пользователем теги (показываются в разделе "Главное") */
        pinnedTags() {
            return this.area?.pinnedTags || [];
        },
        tags() {
            return this.area.tags;
        },
        users() {
            return this.area?.users;
        },
        /** Map id->user для O(1)-поиска вместо users.find() на каждый элемент большого списка задач. */
        usersById() {
            return new Map((this.users || []).map(el => [el.id, el]));
        },
        /** Map id->user для O(1)-поиска вместо users.find() на каждый элемент большого списка задач. */
        usersByAuth() {
            return new Map((this.users || []).map(el => [el.id, el]));
        },
        tariffs() {
            return this.area?.tariffs;
        },
        pickableUsers() {
            return [this.user, ...(this.favoriteUsers || [])];
        },

        // page -------------------
        page() {
            return this.$store.state.page;
        },
        /**
         * Единая точка выбора источника данных контекста (context / tasks / task).
         * Если проект в панельном режиме (group.settings.withPannelView) и компонент лежит в панели - данные панели
         * (page.contexts[index] либо живые данные страницы, если контекст панели открыт на странице);
         * иначе общий state.page. Проверка панельного режима идёт после panelScope, чтобы компоненты вне панелей
         * её не вычисляли.
         */
        contextSource() {
            return this.panelScope && this.isPannelView ? this.panelScope : this.page;
        },
        tasks() {
            return this.contextSource.tasks;
        },
        /**
         * Подзадачи открытой задачи для текстового списка (пункты в тексте задачи). В режиме контекста-задачи (панель,
         * context-content-text) это задачи самого контекста; на странице задачи контекст страницы - родитель, поэтому
         * берём детей открытой задачи (task.children).
         */
        textListSubtasks() {
            const taskId = this.task?.item?.id;
            if (taskId && this.context.item?.id !== taskId) return this.task.children;
            return this.tasks?.items;
        },
        visibleTasks() {
            const items = currentContextVisibleTasks();
            return items?.slice(0, Config.CONTEXT_MAX_TASKS);
        },
        selectedTasks() {
            return this.context.selectedTasks;
            /*get() {
                return this.page.tasks.selectedItems;
            },
            set(v) {
                this.page.tasks.selectedItems = v;
            }*/
        },
        events() {
            return this.page.events;
        },

        // context ---
        context() {
            //console.log("REQUESTING context", this.page.context);
            return this.contextSource.context;
        },
        contextIdChain() {
            if (!this.context.item) return null;
            let chain = [];
            console.log("contextIdChain context.parents", this.context.parents);
            if (this.context.parents?.length) chain = this.context.parents.map(x => x.id);
            chain.push(this.context.item.id);
            return chain.join(Config.CONTEXT_ID_CHAIN_SEP);
            /*const contextIdChainOf = (item, path) => {
                if ( !item ) return path;
                path = path || [];
                if (item?.contextId) {
                    path.push(item?.contextId);
                    const parent = this.tasks.flatItems?.find(el=>el.id===item?.contextId);
                    return contextIdChainOf(parent, path);
                }
                return this.context.navPath;
            }
            return contextIdChainOf(this.context.item);*/
        },
        /**
         * @deprecated - context is now always enriched
         * @returns {*}
         */
        fullContextItem() {
            return fullContextItem(this.context.item, this.area);
        },
        hasFullAccessToContext() {
            return this.context.item?.withFullAccess !== false;
        },
        pick() {
            return this.context.pick;
        },
        group() {
            return this.context.group;
        },
        /** Включён ли для проекта текущего роута панельный режим навигации (group.settings.withPannelView) */
        isPannelView() {
            return this.isRouteContextChain || isPannelViewOfContextId(this.$route.params?.contextId);
        },
        topic() {
            return this.context.topic;
        },
        tag() {
            return this.context.tag;
        },
        usersOfGroup() {
            return this.context.usersOfGroup;
        },
        tab: {
            get() {
                return this.context.tab
            },
            set(v) {
                return this.context.tab = v;
            }
        },
        tabItem() {
            return this.tabItems.find(el => el.id === this.tab);
        },
        isTabDeleted() {
            return this.context.tab === TABS.DELETED;
        },
        /*assignee() {
            return this.context.assignee;
        },*/
        plainContextTasks() {
            if (!this.tasks.items?.length) return null;
            return flatArray(this.tasks.items);
        },
        /**
         * Returns topics and tasks of THIS context.
         * @deprecated
         * @returns {*[]}
         */
        contextJointItems() {
            const items = [...(this.contextTopicItems || []), ...(this.contextTaskItems || [])];
            sortByPrio(items);
            return items;
        },
        /**
         * @deprecated
         * @returns {(function(): (function(): default.computed.area.topics)|null|[]|Topics|(() => Topics)|*)|[]|Topics|(() => Topics)|*}
         */
        contextTopicItems() {
            let items;
            // we show topics only in a group content todo what about picks/users
            if (this.context.item?.isGroup) {
                items = this.tasks.topics;//?.filter(el => el.groupId === this.context.item.id);
            }
            return items;//?.slice(0, Config.CONTEXT_MAX_TASKS);
        },
        /**
         * @deprecated
         * @returns {null|*}
         */
        contextTaskItems() {
            let items = this.tasks.items;
            if (!items) return null;

            // in a group context - we show only topic less tasks
            if (this.context.item?.isGroup) {
                items = items.filter(el => !el.topicId);
            }

            return items?.slice(0, Config.CONTEXT_MAX_TASKS);
        },
        /**
         * @deprecated - we do not have personal groups anymore
         * @returns {*}
         */
        personalGroup() {
            //console.log("personalGroup", this.groups?.find(el => el.isPersonal));
            return this.groups?.find(el => el.isPersonal);
        },
        /**
         * Returns open context (visible ones). Useful for refetching visible context tasks.
         */
        openContextIds() {
            return openContextIds();
        },

        // task -------------------
        task() {
            return this.contextSource.task;
        },
        taskTags() {
            const accessibleTagIds = this.area.tags?.map(el => el.id) || [];
            return this.task?.item?.tagData?.filter(el => accessibleTagIds.includes(el.contextId)
                || Config.PUBLIC_TAG_NAMES.includes((el.contextName || "").trim().toLowerCase()));
        },
        currentContextTask() {
            if (!this.isRouteSomeTask || !this.task.item) return null;
            const allContextTasks = this.plainContextTasks;
            return allContextTasks.find(el => el.id === this.task.item.id || el.id === this.task.item.auth);
        },
        currentContextTaskParents() {
            if (!this.currentContextTask) return null;

            const allContextTasks = this.plainContextTasks;
            const parents = [];
            const poses = splitPos(this.currentContextTask.pos);
            poses.forEach(pos => {
                const p = allContextTasks.find(el => el.pos === pos);
                if (p) parents.push(p);
            });
            return parents;
        },
        editedSubtask() {
            const editedItemId = this.$route.query?.c;
            if (editedItemId) {
                const task = this.task.children?.find(el => el.id === editedItemId);
                if (task) return task;
            }
            return this.task.children?.find(el => this.isTaskDraft(el)
                && !this.isTaskDeleted(el)
                && el.creatorId === this.user.id
            );
        },

        // task timer {
        withActiveTimer() {
            return !!this.$store.state.session.timer;
        },
        isTimerStarted() {
            return this.task.timer?.createdAt && !this.task.timer.stoppedAt;
        },
        isTimerStartedFor1Task() {
            return this.oneTask.item && this.currentTask.item && this.oneTask.item.id === this.currentTask.item.id;
        },
        isTimerStartedNotFor1Task() {
            return this.oneTask.item && this.currentTask.item && this.oneTask.item.id !== this.currentTask.item.id;
        },
        comments() {
            return this.task.children?.filter(el => this.isTaskComment(el) && !this.isTaskDraft(el));
        },

        // draggable --------------------
        draggedElement() {
            return this.$store.state.draggable.lastDragElement;
        },

        // routing --------------------
        isRouteHome() {
            return this.$route.name === "home";
        },
        isRouteMy() {
            const thisUserAuth = this.$store.state.session.user?.id;
            return this.$route.name === "my";
        },
        isRouteContext() {
            return this.$route.name === "context" || this.isRouteContextChain || this.isRouteContextTask;
        },
        /** Роут цепочки контекстов (панельный режим, данные в page.contexts) */
        isRouteContextChain() {
            return this.$route.name === "context-chain";
        },
        isRouteContextTask() {
            return this.$route.name === "context-task";
        },
        isRoute1Task() {
            return this.$route.name === "1task"
                || this.$route.name === "1task-start"
                || this.$route.name === "1task-done";
        },
        isRouteTask() {
            return this.$route.name === "task";
        },
        isRouteSomeTask() {
            return this.isRouteContextTask
                || this.isRoute1Task
                || this.isRouteTask;
        },
        isRouteGroup() {
            return this.$route.name === "group" || this.$route.name === "group-done" || this.isRouteGroupTask;
        },
        isRouteGroupTask() {
            return (this.$route.name === "group-task");
        },
        isRouteAssignee() {
            const thisUserAuth = this.$store.state.session.user?.id;
            return this.$route.name === "assignee" && thisUserAuth !== this.$route.params.assigneeAuth;
        },
        isRouteSearchTask() {
            return this.$route.name === "search-task";
        },
        isRouteUsers() {
            return this.$route.name === "users";
        },
        isRouteSearch() {
            return this.$route.name === "search" || this.isRouteSearchTask;
        },
        isRoute1TaskDone() {
            return this.$route.name === "1task-done";
        },
        isRouteContextDone() {
            return this.isRoute1TaskDone
                || this.$route.name === "context-done";
        },

        // ims --------------------
        /**
         * User available auth IMs, including disabled ones.
         * @returns {{createdAt: string|null, im: *, isEnabled}[]}
         */
        imsWithAuth() {
            return this.IMs.filter(el => el.withAuth).map(im => {
                const createdAt = this.session.ims?.find(el => el.imKey === im.key)?.createdAt;
                return {
                    isEnabled: !!this.session.ims?.find(el => el.imKey === im.key),
                    createdAt: createdAt ? mysql2DDMMYYYY(createdAt) + " " + mysql2HHMM(createdAt) : null,
                    im,
                };
            });
        }
    },
    /*	beforeRouteUpdate(to, from, next){
            console.log("beforeRouteUpdate", to, from);
            //initAuthorization(to);
            next();
        }*/
    methods: {
        emit(...args) {
            this.$emit(...args);
        },
        do(action, params) {
            return this.$store.dispatch("action", {
                action,
                params
            });
        },
        fetch(action, params) {
            return this.$store.dispatch("fetch", {
                action,
                params
            });
        },
        dispatch(name, params) {
            return this.$store.dispatch(name, params);
        },
        commit(name, payload) {
            return this.$store.commit(name, payload);
        },
        snack(params) {
            return this.dispatch("ui/snack", params);
        },
        confirm(params) {
            // todo
        },
        menu(menu, params) {
            return this.$store.dispatch("ui/menu", {
                menu,
                ...params
            });
        },
        /**
         * 1. if task has undone stages - finishes current stage
         * 2. if task is undone - marks it done
         * 3. if task is done - marks it undone
         * 4. is task is now done & we are in 1task mode - route to next task + show snack to cancel taskDone action
         * @param item
         * @param forceValue
         * @returns {Promise<void>}
         */
        async toggleTaskDone(item, forceValue = undefined) {
            const old = {...item};

            // if task is CURRENT + STAGED - mark stage done
            /*if (false && forceValue !== false && item.id === this.$store.state.page.task.item?.id && item.totalStages > 1) {
                // this is a current task with stages - finish displayed stage only
                const contentId = this.$store.state.page.task.item.contentId;
                await this.$store.dispatch("action", {
                    action: "task/stageUpdate",
                    params: {
                        taskId: item.id,
                        contentId,
                        params: {
                            stageDoneAt: date2Iso(new Date()),
                        }
                    }
                });
                if (stage !== this.$store.state.page.task.item.activeStage) {
                    routeToTaskStageItem(item, this.$store.state.page.task.item.activeStage, true);
                }
            } else {*/
            const response = await this.$store.dispatch("task/toggleDone", {
                item,
                forceValue,
            });

            //console.log("this.task.item?.id === item?.id", this.task.item?.id === item?.id);
            //console.log("this.task.stages?.length > 1", this.task.stages?.length > 1);
            if (this.task.item?.id === item?.id && this.task.stages?.length > 1) {
                const stageItem = this.task.stages.find(el => el.contentId === this.task.item?.contentId);
                console.log("this.isTaskStageItemDone(stageItem)", this.isTaskStageItemDone(stageItem));
                if (this.isTaskStageItemDone(stageItem)) {
                    console.log("this.stageItem.contentId === this.item.contentId", this.stageItem.contentId === this.item.contentId);
                    const nextActiveStage = this.task.stages?.find(el => !this.isTaskStageItemDone(el));
                    console.log("nextActiveStage", nextActiveStage);
                    if (nextActiveStage) await routeToTaskStageItem(nextActiveStage);
                }
            }
            //}

            this.make1TaskProgress(item, old, undefined, response);
        },
        async toggleTaskStageItemDone(item, stageItem) {
            const old = {...item};

            const response = await this.$store.dispatch("task/toggleStageDone", {
                taskId: item.id,
                contentId: stageItem?.contentId,
            });

            //console.log("this.isTaskStageItemDone(this.stageItem)", this.stageItem, this.isTaskStageItemDone(this.stageItem));
            if (stageItem && stageItem.contentId === item?.contentId) {
                //console.log("SAME CONTENT ID");
                if (this.isTaskDone(item)) {
                    const undoneStages = this.task.stages?.filter(el => !this.isTaskStageItemDone(el));
                    if (!undoneStages?.length) {
                        this.make1TaskProgress(item, old, undefined, response);
                    }
                } else {
                    // retake stageItem from stage as stage list could change
                    const updatedStageItem = this.task.stages?.find(el => el.contentId === stageItem.contentId);
                    //console.log("updatedStageItem", updatedStageItem);
                    //console.log("this.isTaskStageItemDone(stageItem)", this.isTaskStageItemDone(updatedStageItem));
                    if (this.isTaskStageItemDone(updatedStageItem)) {
                        //console.log("this.stageItem.contentId === this.item.contentId", this.stageItem.contentId === this.item.contentId);
                        const nextActiveStage = this.task.stages?.find(el => !this.isTaskStageItemDone(el));
                        //console.log("nextActiveStage", nextActiveStage);
                        if (nextActiveStage) await routeToTaskStageItem(nextActiveStage);

                    }
                }
            }

        },
        toggleTaskDeferred(item, withForce) {
            let params;
            if (withForce || !this.isTaskDeferred(item))
                params = {
                    deferredAt: date2Iso(new Date()),
                    //isActive: false,
                };
            else params = {
                isActive: true,
                deferredAt: null
            };
            return this.do("task/update", {
                taskId: item.id,
                params
            });
        },
        toggleTopicDone(item) {
            let params;
            if (this.isTopicDone(item))
                params = {
                    doneAt: null,
                };
            else params = {
                doneAt: new Date(),
            }
            return this.do("context/update", {
                contextId: item.contextId,
                params
            });
        },
        toggleContext1TaskMode(item) {
            //console.log("toggleContext1TaskMode", item);
            item = item || this.context.item;
            if (!item) return;

            const willBe1Task = !item.is1Task && !item.isBlock;
            let params = {
                is1Task: item.isTopic ? false : !item.is1Task,
                isBlock: item.isTopic ? !item.isBlock : false,
            };

            //console.log("PARAMS", params);

            return this.do("context/update", {
                contextId: item.contextId,
                params
            }).then(() => {
                if (this.context.item?.contextId === item.contextId) {
                    // we are updating current context
                    if (willBe1Task) {
                        console.log("!!!!");
                        if (!this.isRouteSomeTask) {
                            // route to the first visible task of the current context
                            const firstTask = contextFirstVisibleTask(this.context.item);
                            const redirect = firstTask ? {
                                name: 'context-task',
                                params: {contextId: this.context.item.contextId, taskId: firstTask.auth}
                            } : null;
                            if (redirect) {
                                //small pause for animation
                                setTimeout(() => {
                                    this.$router.push(redirect)
                                }, 300);
                            }
                        }
                    } else if (!this.isMD) {
                        console.log("go to context!!!!!");
                        this.$router.push({name: "context", params: {contextId: this.context.item.contextId}});
                    }
                }
            });
        },
        toggleContextBlockMode(item) {
            item = item || this.context.item;
            if (!item) return;
            const willBeBlock = !item.isBlock;
            return this.do("context/update", {
                contextId: item.contextId,
                params: {
                    isBlock: !item.isBlock,
                    is1Task: false
                }
            }).then(() => {
                if (this.context.item?.contextId === item.contextId) {
                    // we are updating current context
                    if (willBeBlock) {
                        // route to the first visible task of the current context
                        const firstTask = contextFirstVisibleTask(this.context.item);
                        const redirect = firstTask ? {
                            name: 'context-task',
                            params: {contextId: this.context.item.contextId, taskId: firstTask.auth}
                        } : null;
                        if (redirect) {
                            if (redirect.params.taskId !== this.task.item?.auth) {
                                //small pause for animation
                                setTimeout(() => {
                                    this.$router.push(redirect)
                                }, 300);
                            }
                        }
                    }
                }
            });
        },
        async delayReminder(item) {
            const old = {...item};
            //console.log("OLD delayedTill: "+old.delayedTill);

            this.showDialogTaskDelay(item).then((res) => {
                this.make1TaskProgress(item, old, undefined, res?.__response);
            });

            // add 1 day, till 10:00
            /*const date = new Date();
            date.setDate(date.getDate() + 1);
            date.setHours(10);
            date.setMinutes(0);
            await this.do("task/update", {
                taskId: item.id,
                params: {
                    doneAt: null,
                    delayedTill: date2Iso(date),
                },

                // specify filter to receive proper context task indexes data
                //filter: this.context.item?.filter,
                //contextIds: this.openContextIds,
            });*/
            //console.log("NEW delayedTill: "+this.item.delayedTill);
            //console.log("OLD delayedTill after: "+old.delayedTill);
            //this.make1TaskProgress(item, old);
        },
        confirmAndMakeTaskAccessibleByLink(item, withAccessByLink, params) {

            let title, message, options;
            if (withAccessByLink) {
                title = "Открыть доступ по ссылке?";
                message = "Внимание! Задача станет доступна любому пользователю.";
            } else {
                title = "Закрыть доступ по ссылке?";
                message = "Пользователи, не состоящие с Вами в общих группах, потеряют доступ к задаче.";
            }

            params = params || {};
            if (typeof params.title != "undefined") title = params.title;
            if (typeof params.message != "undefined") message = params.message;
            if (typeof params.options != "undefined") options = params.options;

            return this.$store.dispatch("ui/confirm", {
                title,
                message,
                options,
                ok: withAccessByLink ? "Открыть доступ" : "Закрыть доступ"
            }).then(async (options) => {
                this.makeTaskAccessibleByLink(item, withAccessByLink);
            });
        },
        makeTaskAccessibleByLink(item, withAccessByLink) {
            return this.do("task/update", {
                taskId: item.id,
                params: {
                    withAccessByLink
                }
            });
        },
        async storeContextTasksFilterProperty(payload) {
            console.log("storeContextTasksFilterProperty", payload);
            if (typeof payload != "object") return;
            const contextId = this.context.item?.id;
            if (!contextId) return;
            const value = this.user.contextTasksFilter || {};//storage.get(Config.STORAGE_CONTEXT_TASKS_FILTER) || {};
            let c = value[contextId];//.find(el=>el.contextId === contextId);
            if (!c) c = value[contextId] = {};
            Object.keys(payload).forEach(key => {
                c[key] = payload[key];
                //state.ui.contextTasksFilter[key] = value[key] || null;
            });
            c.updatedAt = new Date().valueOf();
            //console.log("storing", value);
            //storage.set(Config.STORAGE_CONTEXT_TASKS_FILTER, value);
            return this.do("user/update", {
                params: {
                    contextTasksFilter: value,
                }
            });
        },
        async followTask(item, followAt = undefined) {
            const old = {...item};
            const response = await this.do("context/followTask", {
                taskId: item.id,
                followAt,
                with1TaskChecking: true,
            });
            this.make1TaskProgress(item, old, () => this.do("context/followTask", {
                taskId: item.id,
                followAt: date2MysqlFull(new Date()),   // setting to now
            }), response);
        },
        async unfollowTask(item, followAt = undefined) {
            const old = {...item};
            const response = await this.do("context/unfollowTask", {
                taskId: item.id,
                with1TaskChecking: true,
            });
            this.make1TaskProgress(item, old, () => this.do("context/followTask", {
                taskId: item.id,
                followAt: date2MysqlFull(new Date()),   // setting to now
            }), response);
        },
        async requestAccessToTaskId(taskId, withFullAccess) {
            //const taskId = item?.id;
            if (!taskId) return;
            await this.do("task/requestAccess", {
                taskId,
                withFullAccess
            });
            this.snack({
                icon: "mdi-information-outline",
                text: "Запрос отправлен",
                color: "blue",
            });
        },
        async addFavoriteUser(event) {
            return this.$store.dispatch("user/assigneeMenu", {
                event,
                title: "Добавить в быстрый доступ",
                preferredTitle: "Все контакты",
                excludeAuths: this.pickableUsers?.map(el => el.id),
                //isUnpreffed: true,
            }).then(res => {
                console.log("USER", res?.user);
                if (res?.user) {
                    this.do("user/favoriteToggle", {
                        userAuth: res.user.id,// || null,
                        isFav: 1,
                    });
                }
            });
        },
        async copyToClipboard(text, withConfirmation = false) {
            await copy(text);
            if (withConfirmation) this.snack({
                text: "Текст скопирован в буфер обмена"
            });
        },
        /**
         * Query-параметры текущего роута для действия, с учётом meta.actions[].queryMap
         * (например, ?tag=x -> tagId=x), чтобы повторный запрос сохранял фильтры страницы.
         * @param {string} actionName
         */
        routeActionQuery(actionName) {
            const action = this.$route.meta?.actions?.find(el => el.action === actionName);
            return mapRouteQuery(this.$route.query, action?.queryMap);
        },
        /**
         * Перезагружает список задач текущего контекста (например, после смены фильтра).
         * Панель с собственными данными перезагружает только свой контекст цепочки: context/chain с updateContextIds,
         * результат ставится в page.contexts[index]; иначе - context/item в state.page.
         */
        reloadContextTasks() {
            if (this.contextSource !== this.page) {
                if (!this.context.item?.id) return;
                return this.do("context/chain", {
                    contextIdChain: chainOfRoute(this.$route).join(Config.CONTEXT_ID_CHAIN_SEP),
                    updateContextIds: [this.context.item.id],
                });
            }
            return this.do("context/item", {
                contextId: this.contextIdChain,
            });
        },
        reloadContext() {
            if (!this.context.item?.id) return;
            return this.do("context/item", {
                contextId: this.context.item.id,
                ...this.routeActionQuery("context/item"),
            });
        },
        reloadTask() {
            if (!this.task.item?.id) return;
            return this.do("task/item", {
                taskAuth: this.task.item.id
            });
        },
        isTaskReminder(item) {
            return isTaskReminder(item);
        },
        isTaskDeleted(item) {
            return isTaskDeleted(item);
        },
        isTaskDone(item) {
            return isTaskDone(item);
        },
        isTaskStageItemDone(stageItem) {
            return isTaskStageItemDone(stageItem);
        },
        /*isStageDone(item) {
            return isTaskDone(item)
                || (item.totalStages > 1 && !!item.stageDoneAt);
        },*/
        isTopicDone(item) {
            return isTopicDone(item);
        },
        /*is1TaskInactive(item) {
            return is1TaskInactive(item);
        },*/
        isContextTaskInactive(context, item) {
            return isContextTaskInactive(context, item);
        },
        isTaskActive(item) {
            return isTaskActive(item);
        },
        isTaskTemplate(item) {
            return isTaskTemplate(item);
        },
        isTaskRepeated(item) {
            return isTaskRepeated(item);
        },
        isTaskDelayed(item) {
            return isTaskDelayed(item);
        },
        isTaskWithDeadline(item) {
            return !!item.deadline;
        },
        isContextDelayed(item) {
            return isContextDelayed(item);
        },
        isTopicDelayed(item) {
            return isTopicDelayed(item);
        },
        isTaskNote(item) {
            return isTaskNote(item);
        },
        isTaskComment(item) {
            return isTaskComment(item);
        },
        isComplexTask(item) {
            return isComplexTask(item);
        },
        isTaskDraft(item) {
            return isTaskDraft(item);
        },
        isTaskFullDraft(item) {
            return isTaskFullDraft(item);
        },
        isTaskDeferred(item) {
            return isTaskDeferred(item);
        },
        isTaskAccessRequest(item) {
            return !!item.accessRequestByUserId;
        },
        isTaskWithLargeContent(item) {
            return isTaskWithLargeContent(item);
        },
        isTopicVirtual(item) {
            return isTopicVirtual(item);
        },
        isTaskInactive(item) {
            return isTaskInactive(item);
        },
        isTaskTemplateActive(item) {
            return isTaskTemplateActive(item);
        },
        isTaskOverdue(item) {
            return isTaskOverdue(item);
        },
        isTaskOfMyAttention(item) {
            return isTaskOfMyAttention(item);
        },
        isTaskOfMaxLevel(task) {
            if (!task) return false;
            return task.level >= Config.TASKS_MAX_LEVEL;
            //return posLevel(task.pos) >= Config.TASKS_MAX_LEVEL;
        },
        countContextInactiveTasks(context) {
            return countContextInactiveTasks(context);
        },
        countContextActiveTasks(context) {
            return countContextActiveTasks(context);
        },
        async createNewGroup() {
            //this.withNewGroupDialog = true;
            //this.commit("soon");
            //const newGroup = await this.$store.dispatch("ui/dialogGroup");
            //console.log("RES in list", newGroup);

            const item = {
                value: "",
            }
            const res = await this.dispatch("ui/dialog", {
                dialog: "dialogInput",
                item,
                title: "Новый проект",
                placeholder: "Название проекта",
                prependIcon: "mdi-folder-outline",
                ok: "Создать",
                callback: (res) => {
                    console.log("dialogInput RES", res);

                    const name = res?.value;

                    this.do("context/createGroup", {
                        params: {
                            name,
                        }
                    })
                        .then(res => {
                            console.log("context/createGroup res", res);
                            const group = res.result?.state?.contextAppend?.item;
                            this.$router.push({name: "context", params: {contextId: group?.auth}});

                            this.commit("tourShow", {
                                id: "on-group-created",
                                delay: 1500,
                                params: {
                                    item: group,
                                },
                            });
                        })
                        .catch((err) => {
                            console.log("error", err);
                        })
                        .finally(() => {

                        });
                }
            });
        },
        createNewTask(contextId, params, query = null, skipRouting = false, withFullscreen = false) {
            //contextId = contextId || this.context.item?.id;
            let skipContext = true;
            if (!contextId) {
                contextId = this.personalGroup?.auth;
                skipContext = false;
            }
            params = params || {};

            return this.do("task/create", {
                contextId,
                //parentId,
                //assigneeAuth,
                params: {
                    ...params,
                    // are we in a template tab?
                    isTemplate: this.context.tab === TABS.TEMPLATES,
                    isNote: this.context.item?.preset === PRESETS.NOTES || this.context.tab === TABS.NOTES,
                },
            }).then(res => {
                //console.log("RES", res);

                if (!skipRouting) {
                    if (res?.result?.state.taskAppend?.item) {
                        const taskId = res?.result?.state.taskAppend?.item.auth || res?.result?.state.taskAppend?.item.id;
                        let params = {
                            // try to keep current context
                            contextId: this.contextIdChain,
                            taskId: taskId,
                            skipContext
                        };
                        query = query || {};
                        this.commit("uiSetRoutingInstructions", {
                            shouldMinimizeComments: true,
                            isOpeningNewTask: true,
                        });
                        //query.n = 1;    // specifies that task is new when opened

                        //console.log("TASK", res?.result?.state.taskAppend?.item);

                        // are we in a template tab? - should keep it
                        /*if (this.context.tab === TABS.TEMPLATES) query.tab = TABS.TEMPLATES;
                        else if (this.context.tab === TABS.NOTES) query.tab = TABS.NOTES;*/

                        //console.log("ROUTING TO", params);

                        if (withFullscreen) this.$router.push({name: "task", params: {taskId}, query});
                        else this.$router.push({name: "context-task", params, query});
                    }
                }

                // return created item
                return res?.result?.state.taskAppend?.item;
            });
        },
        createNewFolder(contextId) {
            //contextId = contextId || this.context.item?.contextId;

            const folder = {};
            this.dispatch("ui/dialogFolder", {
                contextId,
                //parentId,
                item: folder
            }).then(res => {
                console.log("RES", res);
            });
        },
        async publishTask(item) {
            if (!item) {
                return console.warn("publishTask() empty task");
            }
            return this.do("task/publish", {
                taskId: item.id
            }).then(async (res) => {
                console.log("publishTask() res", res);
                // clear uploads only once task/publish is fully done, otherwise a slow
                // publish could let the user attach new files that this would wipe out
                const mutation = isTaskComment(item) ? "commentSetUploads" : "taskSetUploads";
                this.commit(mutation, []);
            }).catch((error) => {
                console.error("publishTask() error:", error);
            });
        },
        async addStage(withPrepend = false, withCloneContent = false) {

            let index, cloneContentFromIndex;
            let selectedStageIndex = this.task.stages?.findIndex(el => el.contentId === this.task.item?.contentId);
            if (selectedStageIndex === -1) selectedStageIndex = 0;
            if (withPrepend) index = selectedStageIndex;
            else index = selectedStageIndex + 1;
            //console.log("index", index);

            if (withCloneContent) cloneContentFromIndex = selectedStageIndex;

            const res = await this.do("task/addStage", {
                taskId: this.task.item.id,
                index,
                cloneContentFromIndex,
            });
            if (!this.task.stages?.length) return;
            let stageItem = this.task.stages[index];
            if (stageItem) return routeToTaskStageItem(stageItem);
        },
        appendSelectedTasks(item, deleteIfExists = false, withFullReplace = false) {
            this.commit("contextAppendSelectedTask", {
                item,
                deleteIfExists,
                withFullReplace
            });
            /*if (!this.selectedTasks) Vue.set(this.page.context, "selectedTasks", []);
            const index = this.selectedTasks.findIndex(el => el.id === item.id);
            if (index >= 0) {
                //if (!keepPrevious && this.selectedTasks.length > 1) this.selectedTasks.splice(index, 1);
                if (deleteIfExists) this.selectedTasks.splice(index, 1);
            } else this.selectedTasks.push(item);*/

            // we should go to context only of more than 1 task is selected
            if (this.selectedTasks.length > 1) {
                if (this.isRouteContextTask) {
                    console.log("this.selectedTasks.length", this.selectedTasks.length);
                    this.routeToCurrentContext({
                        apiless: true
                    });
                }
            }

            //console.log("appendSelectedTasks()", item, this.selectedTasks?.length);
        },
        removeFromSelectedTasks(item) {
            if (!this.selectedTasks) Vue.set(this.page.context, "selectedTasks", []);
            const index = this.selectedTasks.findIndex(el => el.id === item.id);
            if (index >= 0) {
                this.selectedTasks.splice(index, 1);
            }
        },
        hasReadonlyAccessToTask(item) {
            if (!item) return false;
            return item.withReadonlyAccess === true;
        },
        hasSomeAccessToTask(item) {
            if (!item) return false;
            return item.withFullAccess === true || item.withReadonlyAccess === true;
        },
        hasFullAccessToTask(item) {
            //if (this.isAnon) return false;
            if (!item) return false;
            return item.withFullAccess === true;
        },
        delayedDateText(item) {
            if (!item) return false;
            let text = null;
            if (item.delayedTill) {
                let hm = iso2HHMM(item.delayedTill);
                if (hm === "00:00") hm = "";
                else hm = " " + hm;
                text = iso2DDMMYYYY(item.delayedTill) + hm;
            } else if (item.isDelayed) text = "Отложено";
            return text;
        },
        nickOf(user) {
            return nick(user);
        },
        realNameOf(user) {
            return realNameOf(user);
        },
        async showDialogTaskAccess(item, skipUpdateAction = false) {
            const old = {...item};
            let isCancelled;
            const res = await this.$store.dispatch("ui/dialog", {
                dialog: "dialogTaskAccess",
                item,
                skipUpdateAction,
            }).catch((err) => {
                // cancel clicked
                console.log("task/dialogTaskAccess cancelled");
                isCancelled = true;
            });

            if (isCancelled) return;

            console.log("showDialogTaskAccess res", res);
            if (!skipUpdateAction) this.make1TaskProgress(item, old, undefined, res?.__response);

            return res;
        },
        async showDialogTaskDelay(item, skipUpdateAction = false, skipProgress = false, params) {
            const old = {...item};
            let isCancelled;
            const res = await this.$store.dispatch("task/dialog", {
                dialog: "dialogTaskDelay",
                item,
                skipUpdateAction,
                ...(params || {})
            }).catch((err) => {
                // cancel clicked
                console.log("task/dialogTaskDelay cancelled");
                isCancelled = true;
            });

            if (isCancelled) return;

            console.log("showDialogTaskDelay res", res);
            if (!skipUpdateAction && !skipProgress) this.make1TaskProgress(item, old, undefined, res?.__response);

            return res;
        },
        async showDialogTaskDeadline(item, skipUpdateAction = false) {
            const old = {...item};
            let isCancelled;
            //console.log("showDialogTaskDeadline", item);
            const res = await this.$store.dispatch("task/dialog", {
                dialog: "dialogTaskDeadline",
                item,
                skipUpdateAction
            }).catch((err) => {
                // cancel clicked
                //console.warn("task/dialogTaskDeadline err", err);
                console.log("task/dialogTaskDeadline cancelled");
                isCancelled = true;
            });
            if (isCancelled) return;

            console.log("showDialogTaskDeadline res", res);
            if (!skipUpdateAction) this.make1TaskProgress(item, old, undefined, res?.__response);

            return res;
        },
        /**
         * @deprecated not used anymore - we use showDialogTaskDelay()
         * @param item
         * @returns {Promise<any>}
         */
        showDialogTaskDefer(item) {
            return this.$store.dispatch("task/dialog", {
                dialog: "dialogTaskDefer",
                item,
                /*callback: () => {
                    this.onTaskProcessed(item);
                }*/
            });
        },
        /** список "предпочитаемых" пользователей (участники групп задачи + я + текущий контекст-юзер)
         *  и заголовок для него - переиспользуется в showMenuTaskAssign() и во встроенном списке assignment-menu.vue */
        preferredUsersForTask(item, property, preferredUsersGroupIds = null) {
            console.log("preferredUsersForTask, task:", item);
            console.log("preferredUsersForTask, task group ids:", item.groupIds);
            let preferredUsers = [], preferredTitle;
            const groupIds = preferredUsersGroupIds ? preferredUsersGroupIds : (item?.isGroup ? [item.id] : item.groupIds);
            if (groupIds?.length) {
                preferredUsers = this.users?.filter(el => intersection(el.groupIds, groupIds)?.length);
                preferredTitle = (groupIds?.map(id => this.groupById(id)?.name).filter(el => !!el).join(", "));
            }

            if (preferredUsers) {
                // always add current user
                if (!preferredUsers.find(el => el.id === this.user.id)) preferredUsers.push(this.user);
                // always add current assignee
                if (item[property]) {
                    if (!preferredUsers.find(el => el.id === item[property])) {
                        const user = this.users.find(el => el.id === item[property]);
                        if (user) preferredUsers.push(user);
                    }
                }
                // always add current context user
                if (this.context.item?.isUser && !preferredUsers.find(el => el.id === this.context.item.id)) preferredUsers.push(this.context.item);
            }

            return {preferredUsers, preferredTitle};
        },
        showMenuTaskAssign(item, property, event, params = {}, callback, preferredUsersGroupIds = null) {
            let user;
            if (property === "assigneeAuth") property = "userId";
            else if (property === "ownerAuth") property = "ownerId";

            if (item[property]) user = this.users?.find(el => el.id === item[property]);

            const {preferredUsers, preferredTitle} = this.preferredUsersForTask(item, property, preferredUsersGroupIds);

            const notify = (user, withControl) => {
                if (callback) callback(user, withControl);
                else if (item?.id) this.assignTask(item, property, user, withControl);
            };

            return this.$store.dispatch("user/assigneeMenu", {
                event,
                user,
                preferredUsers,
                preferredTitle,
                zIndex: Config.ZINDEX_OVER_DIALOGS + 1,
                ...params,
                // fired when the menu wants to push an assign request without closing itself
                // (e.g. toggling "withController" on an already-assigned task) - kept separate
                // from the promise below, which only ever settles once
                onUpdate: notify,
            }).then(({user, withControl} = {}) => {
                //console.log("USER SET", user, withControl);

                notify(user, withControl);

                //this.appendPreferredUserForTask(user, item);
            });
        },
        /*appendPreferredUserForTask(user, task) {
            const taskUserIds = storage.get(Config.STORAGE_TASK_PREFERRED_USER_IDS) || {};
            let userIds = taskUserIds[task.id];
            if ( !userIds ) userIds = taskUserIds[task.id] = [];
            const userId = user.auth;    // TODO we store auth so far
            if (!userIds?.find(id => id === userId)) userIds.push(userId);
            storage.set(Config.STORAGE_TASK_PREFERRED_USER_IDS, taskUserIds);
        },*/
        deleteTask(item) {
            const old = {...item};
            return this.do("task/delete", {
                taskId: item.id,
                with1TaskChecking: true,

                // specify filter to receive proper context task indexes data
                /*filter: this.context.item?.filter,
                contextIds: this.openContextIds,*/
            }).then((res) => {
                this.make1TaskProgress(item, old, undefined, res);
            });
        },
        restoreTask(item) {
            return this.do("task/update", {
                taskId: item.id,
                params: {
                    doneAt: null,
                    delayedTill: null,
                    deferredAt: null,
                    deletedAt: null,
                },

                // specify filter to receive proper context task indexes data
                //filter: this.context.item?.filter,
                contextIds: this.openContextIds,
            });
        },
        assignTask(item, property, user, withControl) {
            const old = {...item};
            console.log("assignTask", item, property, user, withControl);

            let value;
            if (property === "userId" || property === "assigneeId" || property === "ownerId") value = user?.id;
            else if (property === "userAuth" || property === "assigneeAuth" || property === "ownerAuth") value = user?.id;
            value = value || null;

            const params = {
                taskId: item.id,
                [property]: value,
                with1TaskChecking: true,
            };
            // undefined means "the menu never showed the 'с контролем' switch at all" (e.g. a plain
            // reassignment) - leave the task's existing controllers untouched
            if (withControl !== undefined) params.withControl = withControl;

            return this.do("task/assign", params).then(res => {
                //console.log("RES after assignTask", res);
                this.make1TaskProgress(item, old, undefined, res);
            });
        },
        /*sortTasks() {
            //if (this.isRouteSearch) return;

            return this.do('context/sortTasksByPrio', {
                contextId: this.context.item?.contextId,
                tab: this.context.tab,
            });
        },*/
        parentsOfTask(task) {
            if (!task) return null;
            const parents = [];
            const findParent = (item) => {
                if (item.parent?.id) {
                    parents.push(item.parent);
                    findParent(item.parent);
                }
            }
            findParent(task);
            return parents;
        },
        /**
         * @deprecated - broken, uses task.groupId that is always undefined
         * @param task
         * @returns {*|null}
         */
        groupOfTask(task) {
            return groupOfTask(task);
        },
        topicOfTask(task) {
            return topicOfTask(task);
        },
        tagsOfTask(task) {
            return tagsOfTask(task);
        },
        userOfTask(task) {
            return this.users?.find(el => el.id === task.userId);
        },
        creatorOfTask(task) {
            return this.users?.find(el => el.id === task.creatorId);
        },
        sortedContextTasks(items) {
            //items = items || this.tasks.items;

            /*const tab = this.context.tab;
            const tabItem = this.tabItems.find(el => el.id === tab);
            if (tabItem) {
                if (typeof tabItem?.sort == "function") return tabItem.sort(items);
            }*/

            /*const sortType = sortTypes.find(el => this.context.item?.sortType === el.id);
            if (typeof sortType?.sort == "function") return sortType.sort(items);*/

            //const sortType = sortTypes.find(el => el.id === SORT_TYPES.SMART);
            const sortType = sortTypes.find(el => el.id === SORT_TYPES.INDEX);
            sortType.sort(items);

            return items;
        },
        filteredContextTasks(items, excludedItems, skipContextFilter = false, skipHiddenFilter = false) {
            //items = items || this.tasks;
            if (!items?.length) return items;

            // 1. exclude excluded tasks
            if (excludedItems?.length) {
                items = items.filter(task => !excludedItems.find(el => el.id === task.id));
            }

            // 2. exclude comments
            items = items.filter(task => !isTaskComment(task));

            // 2b. exclude hidden tasks unless the "show hidden tasks" mode is on
            if (!skipHiddenFilter && !this.ui.withHiddenTasks) {
                items = items.filter(task => !isTaskHidden(task));
            }

            // 3. filter with context filter (currently for search only)
            // skipped for dialog-task-move - it must always show the full unfiltered task list
            if (!skipContextFilter && this.context.item?.preset === PRESETS.SEARCH) {
                // 1. groups
                const filteredGroupIds = this.ui.search.groupIds;
                if (filteredGroupIds?.length) {
                    items = items.filter(item => {
                        const intersection = filteredGroupIds.filter(value => item.groupIds?.includes(value));
                        return intersection?.length > 0;
                    });
                }

                // 2. tabs
                const includedTabs = this.ui.search.includedTabs;
                if (includedTabs?.length > 0) {
                    items = items.filter(item => {
                        //console.log("item", item.title);

                        let isMatchingEnabledTab = false;
                        for (let tabId of includedTabs) {
                            //console.log("TAB: "+tabId);
                            const tab = tabs.find(el => el.id === tabId);
                            //.log("\tshouldFilter", tab.isMatching(item));
                            if (tab.isMatching(item)) {
                                isMatchingEnabledTab = true;
                                break;
                            }
                        }

                        return isMatchingEnabledTab;
                    });
                }
                /*const excludedTabs = this.ui.search.excludedTabs;
                if (excludedTabs?.length) {
                    items = items.filter(item => {
                        //console.log("item", item.title);

                        let isMatchingDisabledTab = false;
                        for (let tabId of excludedTabs) {
                            //console.log("TAB: "+tabId);
                            const tab = tabs.find(el => el.id === tabId);
                            //.log("\tshouldFilter", tab.isMatching(item));
                            if (tab.isMatching(item)) {
                                isMatchingDisabledTab = true;
                                break;
                            }
                        }

                        return !isMatchingDisabledTab;
                    });
                }*/
            }

            return items;

            /*return this.items;

            if (!this.items?.length) return this.items;
            const items = this.items;
            sortByPrio(items);
            const sortFoldersFirst = (a, b) => {
                if (a.isFolder && !b.isFolder) return -1;
                if (!a.isFolder && b.isFolder) return 1;
                return 0;
            }
            items.sort(sortFoldersFirst);
            return items;*/
        },
        /**
         * Builds a route to a context (folder/tag/group/pick).
         */
        routeOfContext(context) {
            return routeOfContext(context);
        },
        /**
         * Builds a route to a task within an explicitly given context.
         */
        /** Роут на открытие элемента в новой панели (панельный режим): контекст с добавленным в цепочку id элемента */
        /**
         * Заменяет выделенные задачи текущего контекста (контекста панели либо страницы - см. contextSource).
         * @param items
         */
        setSelectedTasks(items) {
            if (this.contextSource === this.page) this.$store.commit("contextSetSelectedTasks", items);
            else this.panelScope.setSelectedTasks(items);
        },
        routeOfContextAppend(item, parent) {
            return routeOfContextAppend(item, parent);
        },
        routeOfContextTask(context, task) {
            return routeOfContextTask(context, task);
        },
        /**
         * Builds a context-aware route to open a task (see routeOfTask() in utils/task.js).
         */
        routeOfTask(task, parent, forceFolder = false, forceTask = false) {
            return routeOfTask(task, parent, forceFolder, forceTask);
        },
        /**
         * Builds an absolute URL to a task (for copying).
         */
        urlOfTask(task) {
            if (!task) return null;
            const link = [];
            link.push(Config.HOST);
            const route = this.routeOfTask(task);
            link.push(this.$router.resolve(route).href);
            return link.join("");
        },
        /**
         * Builds a route to a task in "1task" mode.
         */
        routeOf1Task(task, apiless = false) {
            return routeOf1Task(task, apiless);
        },
        /**
         * Navigates to a task in "1task" mode.
         */
        async routeTo1Task(task, apiless = false) {
            if (task) {
                this.$router.push({
                    name: "1task",
                    params: {taskId: task.id, apiless},
                    query: {[Config.QUERY_RANDOM_KEY]: Math.random()}
                });
            } else this.$router.push({name: "1task-start", params: {apiless}});
        },
        /**
         * Navigates to the "1task" completion page.
         */
        async routeTo1TaskDone() {
            this.$router.push({
                name: "1task-done",
            });
        },
        /**
         * Navigates to a task without any context (wraps the same-named function from utils/task).
         */
        routeToTask(taskOrTaskId, query = undefined) {
            routeToTask(taskOrTaskId, query);
        },
        /**
         * Navigates to a task within the current context.
         */
        routeToCurrentContextWithTask(taskOrTaskId) {
            let contextId;
            if (this.context.item) contextId = this.context.item.id;
            else {
                // find personal group context
                const group = this.personalGroup;
                contextId = group.auth;
            }

            let taskId;
            if (typeof taskOrTaskId == "object") taskId = taskOrTaskId.id;
            else taskId = taskOrTaskId;

            this.$router.push({
                name: "context-task", params: {
                    contextId,
                    taskId: taskId
                }
            });
        },
        /**
         * Navigates to the current context (e.g. to close an open task).
         */
        routeToCurrentContext(params, query) {
            if (!this.context.item) return null;
            this.$router.push({
                name: "context",
                params: {
                    contextId: this.contextIdChainFor(this.context.item),
                    ...(params || {}),
                },
                query
            });
        },
        /**
         * @deprecated - uses old task.groupId - should be changed
         * @param task
         */
        routeToTaskContext(task) {
            routeToTaskContext(task);
        },
        /**
         * @deprecated - broken! should use contextIdChain
         * @param context
         * @param params
         */
        routeToContext(context, params = {}) {
            this.$router.push({
                name: "context", params: {
                    ...params,
                    contextId: context.id,
                }
            });
        },
        /**
         * Navigates to the home page.
         */
        routeToHome() {
            this.$router.push({name: "home"});
        },
        /**
         * Navigates to the auth page.
         */
        routeToAuth() {
            this.$router.push({name: "auth"});
        },
        /**
         * Navigates to the current task in comment-edit mode.
         */
        routeToEditComment(task) {
            let name, params;
            if (this.isRouteContextTask) {
                name = "context-task";
                params = {
                    contextId: this.contextIdChain,
                    taskId: this.task.item.id,
                }
            } else {
                name = "task";
                params = {
                    taskId: this.task.item.id,
                }
            }

            let query;
            if (task) query = {
                c: task.id,
            };

            this.$router.push({
                name,
                params: {...params, apiless: true},
                query,
            });
        },
        /**
         * Builds the chain of context ids up to the given task (not "the current context chain" - it walks
         * the task's/parent argument's .parent links up the tree). Used as params.contextId for the
         * context/context-task routes.
         */
        contextIdChainFor(task, slice, parent) {
            return contextIdChainFor(task, slice, parent);
        },
        doneTitleOf(task) {
            if (task.totalStages > 1) {
                if (task?.contentId === this.task.item?.contentId) {
                    const selectedStage = this.task.stages?.find(el => el.contentId === this.task.item.contentId);
                    if (selectedStage) {
                        return this.isTaskStageItemDone(selectedStage) ? "Вернуть" : "Готово";
                    }
                    return "Готово";
                    /*const countActiveStages = this.task.stages.reduce((total, item, index) => total + (this.isTaskStageItemDone(item) ? 0 : 1), 0);
                    //console.log("countActiveStages", countActiveStages);
                    if (countActiveStages > 1) {
                        const currentStage = this.task.stages.find(el => el.contentId === this.task.item.contentId);
                        return this.isTaskStageItemDone(currentStage) ? "mdi-progress-check" : "mdi-progress-check";
                    }*/
                }
            } else if (this.isTaskDone(task)) return "Вернуть";
            return "Готово";
        },
        doneIconOf(task) {
            if (task.totalStages > 1) {
                if (task?.contentId === this.task.item?.contentId) {
                    const selectedStage = this.task.stages?.find(el => el.contentId === this.task.item.contentId);
                    if (selectedStage && this.isTaskStageItemDone(selectedStage)) return "mdi-arrow-u-left-top";
                    /*const countActiveStages = this.task.stages.reduce((total, item, index) => total + (this.isTaskStageItemDone(item) ? 0 : 1), 0);
                    //console.log("countActiveStages", countActiveStages);
                    if (countActiveStages > 1) {
                        const currentStage = this.task.stages.find(el => el.contentId === this.task.item.contentId);
                        return this.isTaskStageItemDone(currentStage) ? "mdi-progress-check" : "mdi-progress-check";
                    }*/
                }
                const undoneStages = this.task.stages?.filter(el => !this.isTaskStageItemDone(el));
                return undoneStages?.length === 1 ? "mdi-check" : "mdi-progress-check";
            } else if (this.isTaskDone(task)) return "mdi-arrow-u-left-top";
            return "mdi-check";
        },
        colorByCss(css) {
            if (!css) return null;
            return Config.COLORS.find(el => el.css === css);
        },
        styleOfTag(tag) {
            const s = {};
            if (tag.color) {
                const color = this.colorByCss(tag.color);
                s.backgroundColor = color.color;
                s.color = color.fg;
            } else s.backgroundColor = "grey";
            return s;
        },
        isTagDark(tag) {
            if (tag.color) {
                const color = this.colorByCss(tag.color);
                return color?.dark;
            }
            return true;
        },
        findBy(items, prop, value) {
            return items?.find(el => el[prop] === value);
        },
        contextById(id) {
            return jointContexts(this.$store.state.session.area)?.find(el => el.id === id);
        },
        userById(id) {
            return this.findBy(this.users, "id", id);
        },
        groupById(id) {
            return this.findBy(this.groups, "id", id);
        },
        topicById(id) {
            return this.findBy(this.topics, "id", id);
        },
        groupByContextId(contextId) {
            return this.findBy(this.groups, "contextId", contextId);
        },
        topicByContextId(contextId) {
            return this.findBy(this.topics, "contextId", contextId);
        },
        onTaskProcessed(task) {
            if (this.context.item?.isPick && this.context.item.preset === PRESETS.MY) {

                //console.log("onTaskProcessed", task);
                if (!this.tasks.items?.length) return;
                const plainTasks = flatArray(this.tasks.items);
                const item = plainTasks.find(el => el.id === task.id);
                if (!item) return;
                //console.log("\titem", item);

                // we take only tasks on same level
                let items;
                if (item?.parent) items = item.parent.children;
                else items = this.tasks.items;
                //console.log("items", items);

                const myNextTask = items?.find(el => isTaskOfMyAttention(el));
                console.log("myNextTask", myNextTask);
                if (!myNextTask) {
                    //we've done last task in "my"
                    console.log("Done last task!");
                    this.commit("uiMenu", {
                        menu: this.$store.state.ui.dialogAllDone,
                    });
                }
            }
        },
        /**
         * Checks if we are in 1task mode. Returns if we are not.
         * Both the snack1TaskProcessed text/color AND whether the user's "first" task changed are now
         * decided entirely on the server (see CommandInvocation.with1TaskChecking and
         * describeOneTaskChange() in backend/src/api/Tasks.ts) - this only reacts to response.next1Task.
         * @param item
         * @param old
         * @param undo
         * @param response - the raw WS/HTTP response of the operation that produced item/old, whose
         *   result.next1Task = {taskId, message, color} (if present) drives both the snack and routing
         */
        make1TaskProgress(item, old, undo, response) {
            if (!this.isRoute1Task) return;

            //console.log("make1TaskProgress", item, old);

            let cancelCallback = async item => {
                //console.log("UNDOING 1 TASK", item.title, item.id);
                /*return this.do("task/restore", {
                    taskId: item.id,
                });*/

                // rollback to old item
                if (undo) {
                    // custom undo
                    await undo();
                } else {
                    // standard task update with old values
                    const itemKeys = Object.keys(item);
                    const params = Object.fromEntries(
                        Object.entries(old).filter(([key]) => !itemKeys.includes(key) || old[key] !== item[key])
                    );
                    //console.log("PARAMS TO UNDO", params)
                    await this.do("task/update", {
                        taskId: item.id,
                        params
                    });
                }
                this.routeTo1Task(old);
            }

            // WS responses arrive as {result: {state, key, mutation}} where state is the action's raw
            // return value (see WSService.ts processActionMessage()); HTTP ones are already unwrapped
            // to that raw value directly (see store/api.js) - next1Task lives on the raw value either way
            const next1Task = response?.result?.state?.next1Task ?? response?.next1Task;

            // we always hide snack first
            this.commit("uiHide", "snack1TaskProcessed");
            if (next1Task?.message) {
                this.$nextTick(() => {
                    this.$store.dispatch("ui/snack", {
                        snack: "snack1TaskProcessed",
                        item,
                        text: next1Task.message,
                        color: next1Task.color,
                        cancelCallback,
                    });
                });
            }

            // route to the next task - the server already decided whether the "first" task changed
            if (next1Task) {
                setTimeout(() => {
                    if (next1Task.taskId) this.routeTo1Task({id: next1Task.taskId});
                    else this.routeTo1TaskDone();
                }, 300);
            }
        },
        formatDateTime(date) {
            if (!date) return null;
            if (typeof date == "object") return date2DDMMYYYY(date) + " " + date2HHMM(date);
            if (typeof date == "string") return this.formatDateTime(mysql2Date(date));
            return date;
        },
        formatDate(date) {
            if (!date) return null;
            if (typeof date == "object") return date2DDMMYYYY(date);
            if (typeof date == "string") return this.formatDate(mysql2Date(date));
            return date;
        },
        repeatStatusText(item, prefix) {
            return repeatStatusText(item, prefix);
        }
    }
}
